import PluginDecorator from "./PluginDecorator";
import {PlaylistEventType} from "./PlaylistPluginDecorator";
import {PlayerComponentHookType} from "../../components/wrappers/PlayerComponentWrapper";

require('videojs-overlay/dist/videojs-overlay.js');
require('videojs-overlay/dist/videojs-overlay.css');

export default class OverlayPluginDecorator extends PluginDecorator {

    static readonly PLUGIN_NAME: string = 'overlay';

    static bootingStaticApi() {
        super.bootingStaticApi();
        this.hookManagerInstance.add<PlayerComponentHookType>('BEFORE_SETUP', (videoEl: Element, options: any) => {
            return this.processOptions(options);
        });
    }

    static templates:Object = {
        'full-widht': {

        }
    };

    static processOptions(options: any) {

        options.playlist.forEach(function (playlistItem: any) {

            // extend content property, with html structure
            playlistItem.overlays && playlistItem.overlays.forEach(function(overlayOption:any){
                const {link, content, linkTarget, style} = overlayOption;

                let parsedContent = content;

                if (link) {
                    // wrap text in link tag
                    parsedContent = `<a target="${linkTarget || '_blank'}" href="${link}">${content}</a>`;
                }

                // wrap in custom div and add cancel button
                parsedContent = `<div class="overlay-content" style="${style || ''}">
                                    <span class="vjs-icon-cancel" onclick="this.parentNode.parentNode.className += ' vjs-hidden'"></span> 
                                    ${parsedContent}
                                </div>`;

                overlayOption.content = parsedContent
            });

        });

        return options;

    }


    public bootingExecution(){
        this.eventManager.addListener<PlaylistEventType>('PLAYLIST_UPDATED', (e:any, item:any) => this.updateOverlay(item));
        this.eventManager.addListener<PlaylistEventType>('PLAYLIST_UPDATED',(e:any) => this.updateOverlay());

        // init overlay
        this.updateOverlay();
    }

    // active overlays
    protected activeOverlays:any[] = [];

    protected updateOverlay(currentItem:any = null){
        let currentPlaylistItem = currentItem || this.playlistDecorator.getCurrentItem();

        const currentOverlays = currentPlaylistItem && currentPlaylistItem.overlays;

        // only update overlays, when currentPlaylistItem is changed
        if(currentOverlays && currentOverlays !== this.activeOverlays){

            this.skyClickPlayer.overlay({
                // debug: true, // show debug output of plugin
                overlays: currentOverlays
            });

            // remember current overlays
            this.activeOverlays = currentOverlays;
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/plugins/decorators/OverlayPluginDecorator.ts